var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":"last-pipeline-status"}},[(_vm.hasPipeline)?_c('ci-icon',{staticClass:"gl-align-middle",attrs:{"status":_vm.lastPipelineStatus,"show-status-text":""}}):_c('span',{attrs:{"data-testid":"pipeline-schedule-status-text"}},[_vm._v("\n    "+_vm._s(_vm.s__('PipelineSchedules|None'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }